/**
 * Bundle builder + discount companion: when the bundle-builder variant is in the cart,
 * ensures the companion variant is present at least at matching quantity so Buy X Get Y can apply.
 * Never removes the companion line (discount rules / merchant preference).
 */
(function () {
  const BUNDLE_BUILDER_VARIANT_ID = 42930592055373;
  const COMPANION_VARIANT_ID = 32978354307149;

  let syncQueued = false;
  let syncing = false;

  function sumVariantQty(cart, variantId) {
    if (!cart || !cart.items) return 0;
    const id = Number(variantId);
    return cart.items
      .filter(function (item) {
        return Number(item.variant_id) === id;
      })
      .reduce(function (sum, item) {
        return sum + item.quantity;
      }, 0);
  }

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.ok ? res.json() : null;
  }

  function cartAddJsonUrl() {
    const base = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';
    return base.endsWith('.js') ? base : base + '.js';
  }

  async function refreshCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    try {
      const response = await fetch(window.location.pathname + '?section_id=cart-drawer');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('cart-drawer');
      if (next) drawer.innerHTML = next.innerHTML;
    } catch (e) {
      console.error('[bundle-builder-gift]', e);
    }
  }

  async function syncBundleCompanion() {
    if (syncing) return;
    const cart = await getCart();
    if (!cart) return;

    const builderQty = sumVariantQty(cart, BUNDLE_BUILDER_VARIANT_ID);
    const companionQty = sumVariantQty(cart, COMPANION_VARIANT_ID);

    if (builderQty === 0) return;
    if (companionQty >= builderQty) return;

    const need = builderQty - companionQty;
    syncing = true;
    try {
      const addRes = await fetch(cartAddJsonUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: COMPANION_VARIANT_ID, quantity: need }],
        }),
      });
      const body = await addRes.json().catch(function () {
        return null;
      });
      if (!addRes.ok || (body && body.status)) {
        console.warn('[bundle-builder-gift] cart add failed', body || addRes.status);
        return;
      }
      await refreshCartDrawer();
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } finally {
      syncing = false;
    }
  }

  function queueSync() {
    if (syncQueued) return;
    syncQueued = true;
    window.setTimeout(function () {
      syncQueued = false;
      syncBundleCompanion();
    }, 350);
  }

  document.addEventListener('DOMContentLoaded', queueSync);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      queueSync();
      return Promise.resolve();
    });
  }
})();
